import Vue from 'vue'
import Router from 'vue-router'

// 导入页面组件
import LayOut from '@/views/LayOut.vue'
import ArticleData from '@/views/ArticleData.vue'
import ArticleDetail from '@/views/ArticleDetail.vue'
import MyCollection from '@/views/MyCollection.vue'
import MyLike from '@/views/MyLike.vue'
import UserProfile from '@/views/UserProfile.vue'
import NotFound from '@/views/NotFound.vue'
import RGBColorPalette from '@/views/RGBColorPalette.vue'

Vue.use(Router)

const routes = [
    {
        path: '/',
        redirect: '/article', // 默认重定向到面经列表
        name: "home"
    },
    // 下面这个嵌套的路由一定要记得去配置出口 也就是在LayOut.vue中配置<router-view></router-view> 这样才能在界面切换这些views

    {
        path: '/',
        component: LayOut,  // 布局容器（包含TabBar）
        children: [
            // 面经列表页 - 一级路由
            {
                path: 'article',
                name: "article",
                component: ArticleData,
                meta: {
                    title: '面经列表',
                    icon: 'bi-journal-text',
                    showInTab: true
                }
            },
            // 面经详情页 - 动态路由
            {
                path: 'article/:id',
                name: "articleDetail",
                component: ArticleDetail,
                meta: {
                    title: '面经详情',
                    icon: 'bi-journal-text',
                    showInTab: false  // 不在TabBar显示
                }
            },
            // 收藏页面
            {
                path: 'collection',
                name: "collection",
                component: MyCollection,
                meta: {
                    title: '我的收藏',
                    icon: 'bi-bookmark-heart',
                    showInTab: true
                }
            },
            // 喜欢页面
            {
                path: 'like',
                name: "like",
                component: MyLike,
                meta: {
                    title: '我的喜欢',
                    icon: 'bi-heart-fill',
                    showInTab: true
                }
            },
            // 个人中心
            {
                path: 'user',
                name: "user",
                component: UserProfile,
                meta: {
                    title: '个人中心',
                    icon: 'bi-person-circle',
                    showInTab: true
                }
            },
            // 调色板(基础复习)
            {
                path: 'color',
                name: "color",
                component: RGBColorPalette,
                meta: {
                    title: '颜色',
                    icon: 'bi-palette',
                    showInTab: true
                }

            }

        ]
    },
    // 404 页面
    {
        path: '*',
        component: NotFound,
        name: "notfound"
    }
]

const router = new Router({
    mode: 'history',
    routes
})

// 路由守卫：设置页面标题
// 参数解释:

// to参数: 即将进入的目标路由(Route)对象   包含一些属性  比如:- to.path ：目标路径（如 /article/123 ）
// to.name ：路由名称（如 articleDetail ）
// to.meta ：路由元信息（如 { title: '面经详情' } ）
// to.params ：动态路由参数（如 { id: '123' } ）

// from 参数
// 类型 ：Route 对象
// 含义 ：当前导航正要离开的路由对象
// 用途 ：可以获取来源页面的信息，用于权限判断、返回按钮等

// next 参数
// 类型 ：函数
// 作用 ：控制路由导航流程
// 使用方式 ：
// next() ：继续导航
// next(false) ：中断当前导航
// next('/login') ：跳转到指定路径
// next({ name: 'login' }) ：跳转到命名路由

router.beforeEach((to, from, next) => {
    // 设置页面标题
    // 如果设置了标题，就使用设置的标题，否则使用默认标题(面试宝典) 然后继续导航
    document.title = to.meta.title || '面试宝典'
    next()
})

export default router
